import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'smartlink360-view-renewal-history',
    template:require('./smartlink360-view-renewal-history.component.html'),
    styles:[require('./smartlink360-view-renewal-history.component.css')]
})
export class SmartLink360ViewRenewalHistoryComponent{
    SelectedLicenseDetail;
    renewalHistoryDetail;
    Smartlink360PurchaseLicenseData;
    dialogTitle='View Renewal History'
    error='';
    errorMessage='';
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private dialogRef:MdDialogRef<SmartLink360ViewRenewalHistoryComponent>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else{
            this.SelectedLicenseDetail=this.dialogData.SelectedLicenseDetail;
            this.Smartlink360PurchaseLicenseData=this.dialogData.Smartlink360PurchaseLicenseData;
            this.getRenewalDetails();
        }
    }
    getRenewalDetails(){
        this.isLoading=true;
        this.licenseService.viewSmartLink360RenewalHistory(this.SelectedLicenseDetail.LicenseId).subscribe((data)=>{
           if(!data.IsError && data.DataObject!=null){
                this.renewalHistoryDetail=data.DataObject;
                this.errorMessage='';
           }
           else{
            this.errorMessage=data.Error;
           }
           this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/smartlink360-view-renewal-history/smartlink360-view-renewal-history.component.ts